import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateParticipant(item) {
  return client.post("Participants/CreateParticipant", prepareDataRequest(item));
}

function UpdateParticipant(item) {
  return client.post("Participants/UpdateParticipant", prepareDataRequest(item));
}

function GetParticipants(subrogationId, filterByCourtStatus = false) {
  return client.post(
    "Participants/GetParticipants",
    prepareRequest({ subrogationId, filterByCourtStatus })
  );
}
function GetCourtPreparationParticipants(subrogationId) {
  return client.post(
    "Participants/GetCourtPreparationParticipants",
    prepareRequest({ subrogationId })
  );
}

function GetSubrogationParticipant(id) {
  return client.post(
    "Participants/GetSubrogationParticipant",
    prepareRequest({ id })
  );
}

function UpdateParticipantStatus(item) {
  return client.post(
    "Participants/UpdateParticipantStatus",
    prepareRequest(item)
  );
}

function LastParticipantStatus(participantId) {
  return client.post(
    "Participants/LastParticipantStatus",
    prepareRequest({ Id : participantId })
  );
}

export{
    CreateParticipant,
    UpdateParticipant,
    GetParticipants,
    GetSubrogationParticipant,
    LastParticipantStatus,
    GetCourtPreparationParticipants,
    UpdateParticipantStatus
}